import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const LOGO = "https://customer-assets.emergentagent.com/job_austin-yard-pro/artifacts/h82kv0hn_IMG_4290.png";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("ironclad_admin_token", data.token);
      localStorage.setItem("ironclad_admin_email", data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-background px-6"
    >
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground hover:text-primary mb-8"
          data-testid="back-to-site"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to site
        </Link>

        <div className="flex flex-col items-center gap-3 mb-10">
          <img src={LOGO} alt="Ironclad Yard Services" className="h-24 w-auto object-contain" />
          <div className="text-[10px] tracking-[0.3em] text-primary uppercase">
            Staff Portal
          </div>
        </div>

        <div className="border border-border bg-card/40 p-8">
          <div className="overline mb-2">Admin Login</div>
          <h1 className="font-display text-3xl font-bold uppercase tracking-tight mb-8">
            <Lock className="inline h-6 w-6 text-primary mr-2 -mt-1" />
            Secure Access
          </h1>

          <form onSubmit={onSubmit} className="space-y-5">
            <label className="block">
              <span className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">
                Email
              </span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-background border border-border px-4 py-3 focus:border-primary outline-none"
                data-testid="admin-login-email"
              />
            </label>
            <label className="block">
              <span className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">
                Password
              </span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-background border border-border px-4 py-3 focus:border-primary outline-none"
                data-testid="admin-login-password"
              />
            </label>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {loading ? "Signing In…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
